import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

const TickMarkIcon = ({
  width = 14,
  height = 14,
  color = '#7A7A7A',
}: Props) => (
  <Svg width={width} height={height} viewBox="0 0 12 12" fill="none" testID='tick-mark'>
    <Path
      d="M10 3L4.5 8.5L2 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default TickMarkIcon;
